import {
  LOAD_EVENT_TYPES,
  LOAD_EVENT_TYPES_SUCCESS,
  LOAD_EVENTS,
  LOAD_EVENTS_SUCCESS,
  UPDATE_EVENT,
  UPDATE_EVENT_TYPE,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_TYPE_SUCCESS,
  DELETE_EVENT,
  DELETE_EVENT_TYPE,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_TYPE_SUCCESS,
  LOAD_EVENT,
  LOAD_EVENT_SUCCESS,
  LOAD_LIST_EVENT,
  LOAD_DRAWER_EVENTS_SUCCESS,
  CLEAR_EVENT_TYPES,
  // Event schedule actions
  LOAD_EVENT_SCHEDULES,
  LOAD_EVENT_SCHEDULES_SUCCESS,
  LOAD_EVENT_SCHEDULE,
  LOAD_EVENT_SCHEDULE_SUCCESS,
  UPDATE_EVENT_SCHEDULE,
  UPDATE_EVENT_SCHEDULE_SUCCESS,
  DELETE_EVENT_SCHEDULE,
  DELETE_EVENT_SCHEDULE_SUCCESS,
} from 'constants/ActionTypes';
import { EVENT_TABLE } from 'constants/SettingConstants';

import { getIntlMessage } from 'helpers/utilHelpers';
import { getFiltersByKey, getSearch } from 'selectors/settingsSelectors';
import { toggleEventForm, toggleEventScheduleForm, toggleEventTypeForm } from 'actions/ui/formActions';

// Begin loading of the list event for calendar
export const loadListEvent = (startDate, endDate, successCallback) => {
  return {
    type: LOAD_LIST_EVENT,
    payload: {
      params: { startDate, endDate },
      onSuccess: successCallback,
      onErrorMessage: getIntlMessage('event.load.error'),
    },
  };
};

// Begin loading of the event by id
export const loadEventById = (payload = {}) => {
  return {
    type: LOAD_EVENT,
    payload: {
      ...payload,
      resource: `events/${payload.eventId}`,
      onSuccess: loadEventByIdSuccess,
      onErrorMessage: getIntlMessage('event.load.error'),
    },
  };
};

// Update event by id if loading is succeed
export const loadEventByIdSuccess = (event) => {
  return {
    type: LOAD_EVENT_SUCCESS,
    event,
  };
};

// Begin loading of the events
export const loadEvents = (payload = {}) => {
  return {
    type: LOAD_EVENTS,
    payload: {
      resource: 'events',
      onSuccess: loadEventsSuccess,
      extraFields: ['type', 'schedule'],
      onErrorMessage: getIntlMessage('event.load.error'),
      filters: {
        search: {
          selector: getSearch,
        },
        typeId: {
          selector: (state) => getFiltersByKey(state, { settingKey: EVENT_TABLE }),
          key: 'type',
          skipValue: 'all',
        },
        status: {
          selector: (state) => getFiltersByKey(state, { settingKey: EVENT_TABLE }),
          key: 'status',
          skipValue: 'all',
        },
        scheduled: {
          selector: (state) => getFiltersByKey(state, { settingKey: EVENT_TABLE }),
          key: 'scheduled',
          skipValue: 'all',
        },
      },
      sort: 'startDate',
      ...payload,
    },
  };
};

export const loadDrawerEvents = (dateTo) => {
  return {
    type: LOAD_EVENTS,
    payload: {
      resource: 'events',
      onSuccess: loadDrawerEventsSuccess,
      extraFields: ['type'],
      onErrorMessage: getIntlMessage('event.load.error'),
      filters: {
        status: {
          value: 'active',
        },
        scheduled: {
          value: 'future',
        },
        dateTo: {
          value: dateTo,
        },
      },
      sort: 'startDate',
    },
  };
};
export const loadDrawerEventsSuccess = (events) => {
  return {
    type: LOAD_DRAWER_EVENTS_SUCCESS,
    events,
  };
};

// Update events if loading is succeed
export const loadEventsSuccess = (events) => {
  return {
    type: LOAD_EVENTS_SUCCESS,
    events,
  };
};

// Begin loading of the event types
export const loadEventTypes = (payload = {}) => {
  return {
    type: LOAD_EVENT_TYPES,
    payload: {
      ...payload,
      resource: 'event-types',
      onSuccess: loadEventTypesSuccess,
      onErrorMessage: getIntlMessage('event.type.error'),
    },
  };
};

// Update event types if loading is succeed
export const loadEventTypesSuccess = (eventTypes) => {
  return {
    type: LOAD_EVENT_TYPES_SUCCESS,
    eventTypes,
  };
};

export const clearEventTypes = (eventTypes) => {
  return {
    type: CLEAR_EVENT_TYPES,
    eventTypes,
  };
};

// Event update request
export const updateEvent = (values, resolve, reject) => {
  return {
    type: UPDATE_EVENT,
    promise: { resolve, reject },
    payload: {
      resource: 'events',
      extraFields: ['type', 'schedule'],
      onSuccess: updateEventSuccess,
      afterSuccess: toggleEventForm,
      entityPrimaryKey: 'eventId',
      onSuccessMessage: getIntlMessage('event.update.success'),
    },
    values,
  };
};

// Event update success
export const updateEventSuccess = (event, isModerate = false) => {
  return {
    type: UPDATE_EVENT_SUCCESS,
    isModerate,
    event,
  };
};

// Request to update some event fields
export const updateSomeEventField = (values, payload) => {
  return {
    type: UPDATE_EVENT,
    payload: {
      resource: 'events',
      onSuccess: (values) => updateEventSuccess(values, payload.isModerate),
      entityPrimaryKey: 'eventId',
      ...payload,
    },
    values,
  };
};

// Event type update request
export const updateEventType = (values, resolve, reject) => {
  return {
    type: UPDATE_EVENT_TYPE,
    promise: { resolve, reject },
    payload: {
      resource: 'event-types',
      onSuccess: updateEventTypeSuccess,
      afterSuccess: toggleEventTypeForm,
      entityPrimaryKey: 'typeId',
    },
    values,
  };
};

// Event type update success
export const updateEventTypeSuccess = (eventType) => {
  return {
    type: UPDATE_EVENT_TYPE_SUCCESS,
    eventType,
  };
};

// Sending a request to the server to delete event
export const deleteEvent = (eventId) => {
  return {
    type: DELETE_EVENT,
    payload: {
      resource: 'events',
      entityId: eventId,
      onSuccess: deleteEventSuccess,
      onErrorMessage: getIntlMessage('event.delete.error'),
    },
  };
};

// Delete event if sending succeed
export const deleteEventSuccess = (eventId) => {
  return {
    type: DELETE_EVENT_SUCCESS,
    eventId,
  };
};

// Sending a request to the server to delete event type
export const deleteEventType = (typeId) => {
  return {
    type: DELETE_EVENT_TYPE,
    payload: {
      resource: 'event-types',
      entityId: typeId,
      onSuccess: deleteEventTypeSuccess,
      onErrorMessage: getIntlMessage('event.type.delete.error'),
    },
  };
};

// Delete event type if sending succeed
export const deleteEventTypeSuccess = (typeId) => {
  return {
    type: DELETE_EVENT_TYPE_SUCCESS,
    typeId,
  };
};

// Action for load event schedules
export const loadEventSchedules = (payload = {}) => {
  return {
    type: LOAD_EVENT_SCHEDULES,
    payload: {
      resource: 'schedules',
      onSuccess: loadEventSchedulesSuccess,
      extraFields: ['entityData', 'entityModel'],
      filters: {
        entity: { value: 'event' },
      },
      ...payload,
    },
  };
};
const loadEventSchedulesSuccess = (schedules) => {
  return {
    type: LOAD_EVENT_SCHEDULES_SUCCESS,
    schedules,
  };
};

// Action for load event schedule
export const loadEventSchedule = (payload = {}) => {
  return {
    type: LOAD_EVENT_SCHEDULE,
    payload: {
      resource: `schedules/${payload.scheduleId}`,
      onSuccess: loadEventScheduleSuccess,
      extraFields: ['entityData'],
      filters: {
        entity: { value: 'event' },
      },
      ...payload,
    },
  };
};
const loadEventScheduleSuccess = (schedule) => {
  return {
    type: LOAD_EVENT_SCHEDULE_SUCCESS,
    schedule,
  };
};

// Action for update event schedule
export const updateEventSchedule = (values, payload = {}) => {
  return {
    type: UPDATE_EVENT_SCHEDULE,
    payload: {
      resource: 'schedules',
      extraFields: ['entityData'],
      onSuccess: (schedule) => updateEventScheduleSuccess(values.entityId, schedule),
      afterSuccess: toggleEventScheduleForm,
      entityPrimaryKey: 'scheduleId',
      ...payload,
    },
    values,
  };
};
export const updateEventScheduleSuccess = (eventId, schedule) => {
  return {
    type: UPDATE_EVENT_SCHEDULE_SUCCESS,
    eventId,
    schedule,
  };
};

// Action for delete event schedule
export const deleteEventSchedule = (entityId, payload = {}) => {
  return {
    type: DELETE_EVENT_SCHEDULE,
    payload: {
      resource: 'schedules',
      onSuccess: deleteEventScheduleSuccess,
      entityId,
      ...payload,
    },
  };
};
export const deleteEventScheduleSuccess = (scheduleId) => {
  return {
    type: DELETE_EVENT_SCHEDULE_SUCCESS,
    scheduleId,
  };
};
